<template>
  <grid-container-fi
    :class="{
      'newsroom-contact-persons-fi': true,
      'newsroom-contact-persons-fi--wide': contactPersons.length > 1,
    }"
  >
    <div
      v-for="(person, idx) in contactPersons"
      :key="idx"
      class="newsroom-contact-persons-fi__person"
    >
      <div class="newsroom-contact-persons-fi__person__image">
        <cloud-image-fi
          :src="person.fields?.image?.value?.src"
          :alt="person.fields?.image?.value?.alt"
          params="func=crop&org_if_sml=0"
          full-height
        />
      </div>

      <div class="newsroom-contact-persons-fi__person__details-column">
        <div class="newsroom-contact-persons-fi__person__info">
          <div
            v-if="author"
            class="newsroom-contact-persons-fi__person__author"
          >
            {{ author }}
          </div>
          <div
            v-if="person.fields?.name?.value"
            class="newsroom-contact-persons-fi__person__contact-name"
          >
            {{ person.fields?.name.value }}
          </div>
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="person.fields?.role?.value"
            class="newsroom-contact-persons-fi__person__role"
            v-html="roleModified(person.fields?.role.value)"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>

        <div class="newsroom-contact-persons-fi__person__details">
          <a
            v-if="person.fields?.phonenumber1?.value"
            :href="getTel(person.fields?.phonenumber1.value)"
            class="newsroom-contact-persons-fi__person__number"
          >
            <icon-fi
              class="newsroom-contact-persons-fi__person__details-icon"
              icon="phone-call"
            />
            <span>{{ person.fields?.phonenumber1.value }}</span>
          </a>
          <a
            v-if="person.fields?.phonenumber2?.value"
            :href="getTel(person.fields?.phonenumber2.value)"
            class="newsroom-contact-persons-fi__person__number"
          >
            <icon-fi
              class="newsroom-contact-persons-fi__person__details-icon"
              icon="phone-call"
            />
            <span>{{ person.fields?.phonenumber2.value }}</span>
          </a>
          <a
            v-if="person.fields?.fax?.value"
            :href="getFax(person.fields?.fax.value)"
            class="newsroom-contact-persons-fi__person__number"
          >
            <icon-fi
              class="newsroom-contact-persons-fi__person__details-icon"
              icon="printer"
            />
            <span>{{ person.fields?.fax.value }}</span>
          </a>
          <a
            v-if="person.fields?.email?.value"
            :href="getMailto(person.fields?.email.value)"
            class="newsroom-contact-persons-fi__person__mail"
          >
            <icon-fi
              class="newsroom-contact-persons-fi__person__details-icon"
              icon="mail"
            />
            <span>
              <template v-if="person.fields?.emailLabel?.value">
                {{ person.fields?.emailLabel.value }}
              </template>
              <template v-else>
                {{ person.fields?.email.value }}
              </template>
            </span>
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="link?.value?.href || link?.value?.url"
      class="newsroom-contact-persons-fi__download-link"
    >
      <a
        class="newsroom-contact-persons-fi__download-link__file-link button-fi__primary button-fi--large"
        :href="link?.value?.href || link?.value?.url"
        target="_blank"
        download
        @click="handleDownload"
      >
        <div class="newsroom-contact-persons-fi__download-link__file-link-content">
          <div class="newsroom-contact-persons-fi__download-link__file-download-icon">
            <icon-fi
              class="newsroom-contact-persons-fi__download-link__file-download-icon-svg"
              icon="download"
            />
          </div>
          <div class="newsroom-contact-persons-fi__download-link__file-name">
            {{ link?.value?.text }}
          </div>
        </div>
      </a>
    </div>
  </grid-container-fi>
</template>

<script>
import { IconFi } from 'atoms';
import CloudImageFi from 'components/atoms/cloud-image-fi/CloudImageFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import { getFaxHref, getMailToHref, getTelHref } from 'utils/linkHelper';

import eventHubMixin from '@/mixins/eventHubMixin.vue';
export default {
  name: 'NewsroomContactPersonsFi',
  components: {
    IconFi,
    CloudImageFi,
    GridContainerFi,
  },
  mixins: [eventHubMixin],
  props: {
    link: {
      type: Object,
      default: () => ({}),
    },
    contactPersons: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    author() {
      return this.$dict.get('newsroom.Detail-Page.Author');
    },
  },
  methods: {
    getTel(tel) {
      return getTelHref(tel);
    },
    getFax(fax) {
      return getFaxHref(fax);
    },
    getMailto(mail) {
      return getMailToHref(mail);
    },
    roleModified(role) {
      return role.replace(/,/g, ',<br />');
    },
    handleDownload() {
      let url = this.link?.value?.href || this.link?.value?.url;
      this.sendEvent('custom', {}, 'download', {
        link: url,
        name: this.link?.value?.text,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './newsroom-contact-persons-fi';
</style>
